import { render, staticRenderFns } from "./DeviceRow.vue?vue&type=template&id=2afb4801"
import script from "./DeviceRow.vue?vue&type=script&lang=js"
export * from "./DeviceRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports